

















































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Watch } from 'vue-property-decorator';
import { PopupDto } from '@/dto';
import PopupService from '../../../services/popup.service';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import { CONST_YN, YN } from '@/common';
import { CodeManagementDto } from '@/services/init/dto';
import CodeManagementService from '../../../services/code-management.service';
import { LINK_TYPE } from '@/services/shared';
import { EditorConfig } from '@/config';
import { VueEditor } from 'vue2-editor';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'PopupDetail',
  components: {
    VueEditor,
  },
})
export default class PopupDetail extends BaseComponent {
  private popupDto = new PopupDto();
  private popupUpdateDto = new PopupDto();

  private showYn: YN[] = [...CONST_YN];
  private popupTypeSelect: CodeManagementDto[] = [];
  private linkTypeSelect: CodeManagementDto[] = [];
  private imageChanged = false;
  private newPopupImage: FileAttachmentDto[] = [];
  private newPopupMobileImage: FileAttachmentDto[] = [];

  private editorToolbar = EditorConfig;

  getLinkUrl(linkUrl: string) {
    if (linkUrl) {
      return linkUrl.includes('//') ? linkUrl : `//${linkUrl}`;
    }
  }

  getTypeCodes() {
    CodeManagementService.findAnyCode('POPUP').subscribe(res => {
      this.popupTypeSelect = res.data;
    });
    CodeManagementService.findAnyCode('LINK_TYPE').subscribe(res => {
      this.linkTypeSelect = res.data;
    });
  }

  findOne(id) {
    PopupService.findOne(id).subscribe(res => {
      if (res) {
        this.popupDto = res.data;
        this.popupUpdateDto = this.popupDto;
        this.popupUpdateDto.started = new Date(this.popupDto.started);
        this.popupUpdateDto.ended = new Date(this.popupDto.ended);
      }
    });
  }

  showUpdateModal() {
    this.popupUpdateDto = this.popupDto;
    this.findOne(this.$route.params.id);
  }

  // upload popup image
  async uploadPopup(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.POPUP, [
        file,
      ]);
      this.newPopupImage = [];
      this.newPopupImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.imageChanged = true;
      console.log(this.newPopupImage);
    }
  }

  removePopupImage() {
    this.newPopupImage = [];
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  updatePopup() {
    if (this.newPopupImage.length > 0) {
      this.popupUpdateDto.images = this.newPopupImage;
    } else {
      delete this.popupUpdateDto.images;
    }
    const startedDate = new Date(this.popupUpdateDto.started);
    const endedDate = new Date(this.popupUpdateDto.ended);
    this.popupUpdateDto.started = new Date(
      startedDate.getFullYear(),
      startedDate.getMonth(),
      startedDate.getDate(),
      0,
      0,
      0,
    );
    this.popupUpdateDto.ended = new Date(
      endedDate.getFullYear(),
      endedDate.getMonth(),
      endedDate.getDate(),
      23,
      59,
      59,
    );

    PopupService.update(this.$route.params.id, this.popupUpdateDto).subscribe(
      res => {
        if (res) {
          toast.success('수정완료');
          this.findOne(this.$route.params.id);
        }
      },
    );
  }

  deleteOne() {
    PopupService.deleteOne(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('삭제완료');
        this.$router.push('/popup');
      }
    });
  }

  created() {
    this.findOne(this.$route.params.id);
    this.getTypeCodes();
  }
}
